// extracted by mini-css-extract-plugin
export default {"stripeConnect":"StripeConnect_stripeConnect__exIgb","buttonBlock":"StripeConnect_buttonBlock__yVOXb"};